import { combineReducers } from 'redux'
import site from './site'

export default combineReducers({
  site
})